import React, { useState } from "react";
import { Dropzone } from "./DropZone";
import {
    UploadTitleBlock,
    UploadTitleText,
    ButtonWrapper,
    UploadButton,
    UploadNetworkMessage,
    ReleasesAccordion,
    ReleasesHeader,
    ReleasesHeaderText,
    ReleasesHeaderLabel,
    ReleasesHeaderIcon,
    Chevron,
    ReleasesContent,
    ReleasesInner,
    ReleasesBody,
} from "../../UploadForm.elements";
import UploadStepper from "../../UploadStepper";
import { useNetworkQuality } from "@/components/hooks";
import { NETWORK_QUALITY, getNetworkQualityMessage } from "@/utils/networkQuality";

const VideoUpload = ({
                         clipsFiles,
                         setClipsFiles,
                         releasesFiles,
                         setReleasesFiles,
                         isReleasesOpen,
                         setIsReleasesOpen,
                         handleNext,
                    }) => {
    const [clipsOverLimit, setClipsOverLimit] = useState(false);
    const networkQuality = useNetworkQuality();
    const isOffline = networkQuality?.normalizedQuality === NETWORK_QUALITY.OFFLINE;
    const offlineMessage = getNetworkQualityMessage(NETWORK_QUALITY.OFFLINE);

    const canContinue = clipsFiles.length > 0 && !clipsOverLimit && !isOffline;

    return (
        <>
            <UploadTitleBlock>
                <UploadTitleText>UPLOAD CLIPS</UploadTitleText>
            </UploadTitleBlock>

            <UploadStepper step={1} />

            <Dropzone
                files={clipsFiles}
                setFiles={setClipsFiles}
                onTotalSizeChange={({ isOverLimit }) => setClipsOverLimit(isOverLimit)}
                accept={{ "video/*": [] }}
                inputTestId="upload-file-input"
                dropzoneTestId="upload-dropzone"
                title="Add your assets"
            />

{/*            <div
                style={{
                    height: 1,
                    background: "rgba(255, 255, 255, 0.12)",
                    marginBottom: 18,
                }}
            />*/}
            
            {/*<ReleasesAccordion>*/}
            {/*    <ReleasesHeader*/}
            {/*        type="button"*/}
            {/*        onClick={() => setIsReleasesOpen((v) => !v)}*/}
            {/*        aria-expanded={isReleasesOpen}*/}
            {/*    >*/}
            {/*        <ReleasesHeaderText>Add Releases</ReleasesHeaderText>*/}
            {/*        <Chevron open={isReleasesOpen}>*/}
            {/*            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">*/}
            {/*                <path*/}
            {/*                    d="M6 10l6 6 6-6"*/}
            {/*                    stroke="currentColor"*/}
            {/*                    strokeWidth="2"*/}
            {/*                    strokeLinecap="round"*/}
            {/*                    strokeLinejoin="round"*/}
            {/*                />*/}
            {/*            </svg>*/}
            {/*        </Chevron>*/}
            {/*    </ReleasesHeader>*/}
            
            {/*    <ReleasesContent open={isReleasesOpen}>*/}
            {/*        <ReleasesInner>*/}
            {/*            <ReleasesBody open={isReleasesOpen}>*/}
            {/*                <Dropzone*/}
            {/*                    files={releasesFiles}*/}
            {/*                    setFiles={setReleasesFiles}*/}
            {/*                    accept={{*/}
            {/*                        "image/*": [],*/}
            {/*                        "application/pdf": [],*/}
            {/*                    }}*/}
            {/*                />*/}
            {/*            </ReleasesBody>*/}
            {/*        </ReleasesInner>*/}
            {/*    </ReleasesContent>*/}
            {/*</ReleasesAccordion>*/}

            {/*    <ReleasesContent open={isReleasesOpen}>*/}
            {/*        <ReleasesInner>*/}
            {/*            <ReleasesBody open={isReleasesOpen}>*/}
            {/*                <Dropzone*/}
            {/*                    files={releasesFiles}*/}
            {/*                    setFiles={setReleasesFiles}*/}
            {/*                    accept={{*/}
            {/*                        "image/*": [],*/}
            {/*                        "application/pdf": [],*/}
            {/*                    }}*/}
            {/*                    inputTestId="upload-release-file-input"*/}
            {/*                    dropzoneTestId="upload-release-dropzone"*/}
            {/*                    title="Add your releases"*/}
            {/*                />*/}
            {/*            </ReleasesBody>*/}
            {/*        </ReleasesInner>*/}
            {/*    </ReleasesContent>*/}
            {/*</ReleasesAccordion>*/}

            <ButtonWrapper>
                <UploadButton
                    onClick={handleNext}
                    disabled={!canContinue}
                    data-testid="upload-add-metadata-button"
                    data-tour="upload-continue-button"
                >
                    Continue
                </UploadButton>
            </ButtonWrapper>
            {isOffline && offlineMessage && (
              <UploadNetworkMessage role="alert">
                {offlineMessage}
              </UploadNetworkMessage>
            )}
        </>
    );
};

export default VideoUpload;
